import type { State } from '../../types';

export function singleUserVersion(state: State): boolean {
  return state.organization?.singleUser === true;
}
